<template>

  <modal-layout
    :bgShow="modalImage.bg"
    :modalShow="modalImage.modal"
    @close="close">

    <div
      class="image-modal">
      <div
        class="image-modal__head">
        <div>
          {{ modalImage.title }}
        </div>
        <a
          href="/close"
          @click.prevent="close()"
          class="close">
          <img
            src="@/../static/img/icons/close.svg">
        </a>
      </div>
      <div
        class="image-modal__body">
        <img
          :src="modalImage.image">
      </div>
    </div>

  </modal-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import ModalLayout from './ModalLayout';

export default {
  components: {
    ModalLayout,
  },
  computed: {
    ...mapState('layout', ['modalImage']),
  },
  methods: {
    ...mapMutations('layout', ['SET_MODAL_IMAGE']),

    close() {
      this.SET_MODAL_IMAGE({
        modal: false,
        bg: false,
        title: '',
        image: '',
      });
    },
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/image-modal.sass'
</style>
